export default __webpack_public_path__ + "static/media/clear_icon.77fa9fd5.svg";